import type { EnumsV1FeatureId, SettingsV1FeatureLimit } from '@sdk/Api'

export function isFeatureAvailiable(
	feature: EnumsV1FeatureId,
	features: EnumsV1FeatureId[],
	featuresLimits: SettingsV1FeatureLimit[],
	usage: number | null = null,
) {
	const featureExists = features.includes(feature)
	if (!featureExists) return false
	if (usage === null) return true

	const featureLimit = featuresLimits.find((f) => f.featureId === feature)
	return featureLimit ? parseInt(featureLimit.params.maxCount) > usage : true
}
